/** The event is scheduled but registration is not open yet */
export const ANNOUNCED = 'ANNOUNCED';
/** Registration is open */
export const REGISTRATION = 'REGISTRATION';
/** This stream never happened. */
export const CANCELLED = 'CANCELLED';
/** Time when the streamer may start the game play. */
export const PENDING_START = 'PENDING_START';
/** Stream is starting up, transactions towards the streamers account is ongoing. registration is closed. */
export const STARTING = 'STARTING';
/** Stream is active */
export const RUNNING = 'RUNNING';
/** Stream is in a 'pause mode' where registration is open. */
export const INTERMISSION = 'INTERMISSION';
/** Stream is over, but visible */
export const ENDED = 'ENDED';
/** Stream is over, and no longer visible */
export const ARCHIVED = 'ARCHIVED';

export const SESSION_OFFLINE = 'OFFLINE';
export const SESSION_ONLINE = 'ONLINE';
export const SESSION_OFFLINE_RESULT = 'OFFLINE_RESULT';

export const SESSION_SORT_ORDER = [SESSION_ONLINE, SESSION_OFFLINE_RESULT, SESSION_OFFLINE].reduce(
	(acc, current, index) => {
		acc[current] = index;
		return acc;
	},
	{}
);

export const BEFORE_RUNNING_STATES = [REGISTRATION, ANNOUNCED, PENDING_START];

export const BUY_IN_STATES = [REGISTRATION, ANNOUNCED, PENDING_START];

export const PREVIEW_STATES = [REGISTRATION, ANNOUNCED, PENDING_START];

export const LIVE_STATES = [PENDING_START, RUNNING];

export const UPCOMING_STATES = [REGISTRATION, PENDING_START, RUNNING, ANNOUNCED];

export const PAST_STATES = [ENDED, CANCELLED, ARCHIVED];

export const DETAIL_VIEW_STATES = [PENDING_START, RUNNING, REGISTRATION, ANNOUNCED];

export const START_STOP_SWITCHABLE_STATES = [PENDING_START, RUNNING];

export const STREAM_SORT_ORDER = [
	RUNNING,
	STARTING,
	PENDING_START,
	REGISTRATION,
	ANNOUNCED,
	INTERMISSION,
	CANCELLED,
	ENDED,
	ARCHIVED
].reduce((acc, current, index) => {
	acc[current] = index;
	return acc;
}, {});

export const streamSorter = (streamA, streamB) => STREAM_SORT_ORDER[streamA.state] - STREAM_SORT_ORDER[streamB.state];
